const orderConfigurationsStorage = new Map();

const orderConfigurations = {
  get(collection) {
    if (orderConfigurationsStorage.has(collection)) {
      return orderConfigurationsStorage.get(collection);
    }

    return this.set(collection);
  },

  getItemOrder(item) {
    let result;

    orderConfigurationsStorage.forEach((configuration) => {
      if (item in configuration) {
        result = configuration[item];
      }
    });

    return result || 0;
  },

  calculateOrder(collection) {
    return collection.reduce(
      (result, item, index) => ({
        ...result,
        [item]: index,
      }),
      {}
    );
  },

  set(collection) {
    const priorities = this.calculateOrder(collection);

    orderConfigurationsStorage.set(collection, priorities);

    return priorities;
  },
};

export default orderConfigurations;
